export default __webpack_public_path__ + "static/media/Pickpocket's Tunic of the Final Way.a340f018.jpg";